<template>
<div>
  <Header />
  <LoadingDialog
    ref="LoadingDialog"
    message="Loading data..."
    specific
  />
  <v-container grid-list-md fluid class="container-style">
    <div class="container-header">
      <span>Online Enrollment Detail</span>
    </div>

    <v-layout>
      <v-flex xs12>
        <v-card class="no-shadow-print">
          <div>
            <div class="hide-on-view" style="text-align: center;">
              <img :src="require('@/assets/img/logo.png')" style="width:150px;">
            </div>
            <v-toolbar flat color="white" class="pt-2" style="margin-top: 21px;">
              <v-layout row wrap>
                <v-flex xs8 md4 class="title" style="margin-top: 40px;">
                  <v-text-field
                    label="LRN"
                    :value="onlineEnrollment.lrn"
                    disabled
                    class="title font-weight-black disabled-field"
                  ></v-text-field>
                </v-flex>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-btn color="#091D3B" outline @click="$router.push({name: 'online-enrollments'})" class="hide-on-print">Back</v-btn>
                <v-btn class="button-style-blue hide-on-print" onClick="window.print()">Print</v-btn>
                <v-dialog v-model="dialog" persistent max-width="400">
                  <template v-slot:activator="{ on }">
                    <v-btn class="button-style-blue hide-on-print" v-on="on">Approve Enrollment
                      <v-icon style="vertical-align: middle; margin-left: 5px">mdi-arrow-top-right</v-icon>
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline">Approve Enrollment</v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-autocomplete
                              :items="students"
                              item-text="full_name"
                              v-model="selectedStudent"
                              item-value="id"
                              color="#091D3B"
                              label="Student *"
                            >
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#091D3B" outline @click="dialog = false" class="hide-on-print">Cancel</v-btn>
                      <v-btn class="button-style-blue hide-on-print" @click="approve()">Approve Enrollment
                        <v-icon style="vertical-align: middle; margin-left: 5px">mdi-arrow-top-right</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

              </v-layout>
            </v-toolbar>
          </div>
          <v-container grid-list-md class="fluid-full">
            <v-layout row wrap>
              <v-flex xs12 class="mb-1">
                <v-card>
                  <v-toolbar flat color="white" class="pt-2">
                    <span class="title"><strong>Student Details</strong></span>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card-title class="mx-4">
                        <v-layout row wrap>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Last Name"
                              :value="onlineEnrollment.student_last_name"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="First Name"
                              :value="onlineEnrollment.student_first_name"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Middle Name"
                              :value="onlineEnrollment.student_middle_name"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              label="Address"
                              :value="onlineEnrollment.student_address"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Birthday"
                              :value="onlineEnrollment.student_age"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Gender"
                              :value="onlineEnrollment.student_gender_display"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Religion"
                              :value="onlineEnrollment.student_religion"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Telephone Number"
                              :value="onlineEnrollment.telephone_number"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Mobile Number"
                              :value="onlineEnrollment.mobile_number"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Nationality"
                              :value="onlineEnrollment.student_nationality"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <v-flex xs12 class="mb-1 parents-information">
                <v-card>
                  <v-toolbar flat color="white" class="pt-2">
                    <span class="title"><strong>Parents Information</strong></span>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card-title class="mx-4">
                        <v-layout row wrap>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Father"
                              :value="onlineEnrollment.father_name"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Occupation"
                              :value="onlineEnrollment.father_occupation"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Company"
                              :value="onlineEnrollment.father_company"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Mother"
                              :value="onlineEnrollment.mother_name"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Occupation"
                              :value="onlineEnrollment.mother_occupation"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Company"
                              :value="onlineEnrollment.mother_company"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>

                        </v-layout>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex xs12 md12 class="mb-1 pagebreak">
                <v-card>
                  <v-toolbar flat color="white" class="pt-2">
                    <span class="title"><strong>Other Information</strong></span>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card-title class="mx-4">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field
                              label="Previous School"
                              :value="onlineEnrollment.student_previous_school"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              label="Language spoken at home"
                              :value="onlineEnrollment.language_spoken"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>
<style media="screen">
.hide-on-view {
  display: none!important;
}
@media print {
  @page {
    size: auto;
    margin: 0;
    margin-bottom: 0mm!important;
  }
  * {
    margin: 0!important;
  }
  .pagebreak { page-break-before: auto; break-after: auto; }
  .container {
    margin: 0!important;
    padding: 0!important;
  }
  .container-style {
    border: none!important;
    box-shadow: none!important;
    background-color: unset!important;
    margin: 0!important;
  }
  .parents-information {
    margin-top: 100px!important;
  }
  .container.fluid {
    max-width: 100%!important;
  }
  .hide-on-view {
    display: block!important;
  }
  .container-header, .hide-on-print, #Header, #Footer {
    display: none!important;
  }
  .container.grid-list-md .layout .flex {
    width: 100%!important;
  }
  .no-shadow-print {
    box-shadow: none!important;
  }
}
</style>
<script type="text/javascript">
import axios from "axios";
import {
  mapState,
  mapActions
} from "vuex";

import Header from '@/components/Header.vue'
import PaymentModal from '@/components/PaymentModal.vue'
import EnrollmentModal from '@/components/EnrollmentModal.vue'
import LoadingDialog from '@/components/LoadingDialog.vue'


export default {
  components: {
    Header,
    EnrollmentModal,
    PaymentModal,
    LoadingDialog
  },
  computed: {
    ...mapState([
      'onlineEnrollment'
    ]),
  },
  data() {
    return {
      dialog: false,
      students: [],
      selectedStudent: null,
    }
  },
  methods: {
    ...mapActions([
      'getOnlineEnrollment'
    ]),
    approve() {
      const id = this.$route.params.id;
      axios.post(`/api/online-enrollment/${id}/approve/`, { student_id: this.selectedStudent })
        .then((res) => {
          this.$router.push({ name: 'student-detail', params: { id: res.data } });
          this.$toastr('success', 'Student added', '');
        })
        .catch((res) => {
          console.log(res);
        })
    }
  },
  created() {
    this.getOnlineEnrollment(this.$route.params.id)
    axios.get(`/api/student/choices/`)
      .then((res) => {
        const students = res.data.map((student) => ({
          full_name: `${student.last_name}, ${student.first_name} ${student.middle_name}`,
          id: student.id,
        }));
        this.students = [{ id: null, full_name: 'New Student' }, ...students];
        console.log(this.students);
      })
      .catch((res) => {
        console.log(res);
      })
  },
}
</script>
